export default {
  red: '#FF9F9F',
  redLight: '#FF9F9F',
  redDark: '#ef7e7e',
  redBlack: '#ef7e7e',

  purple: '#b48db7',
  purpleLight: '#c19fc3',
  purpleDark: '#834087',
  purpleBlack: '#572a5a',

  orange: '#ffc374',
  orangeLight: '#f9d9b5',
  orangeDark: '#ef8d21',
  orangeBlack: '#774610',

  green: '#a2cc7f',
  greenLight: '#d0e5be',
  greenDark: '#72b33d',
  greenBlack: '#39591e',

  blue: '#74c0e7',
  blueLight: '#9cd2ee',
  blueDark: '#39a6dd',
  blueBlack: '#1c536e',

  yellow: '#fcd574',
  yellowLight: '#fdeaba',
  yellowDark: '#fac032',
  yellowBlack: '#644c14',

  teal: '#6ec8b7',
  tealLight: '#aed9d1',
  tealDark: '#5eb4a4',
  tealBlack: '#2f5a52',

  black: '#bbbbbb',
}
